import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean {

    if (localStorage.getItem('currentUser')) {
      return true;
    }

    this.router.navigate(['/pages/appointment-form']);
    return false;
  }
}
